<template>
    <b-modal id="info" size="xl" title="Інформація по коду ЄДРПОУ з сервісу VKURSI" v-model="modalShow" centered scrollable>
        <div class="company_info" >

        <span>
             <b-button variant="outline-primary" @click="update_item" class="mb-2 mt-2">Оновити інформацію</b-button> </span>
                <b-overlay :show="this.is_update">
                    <span  v-if="rows.hasOwnProperty('udata')"> <span> Дата оновлення:</span> {{rows.date}} </span>
                
                        <div  v-if="rows.hasOwnProperty('udata')">
                            <b-row>
                                <b-col md="6">
                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-button block v-b-toggle.collapse-a variant="success">Загальна інформація <span v-if="chk_info" class="text-danger"><i class="far fa-exclamation-triangle"></i></span></b-button>
                                        </b-card-header>
                                        <b-card-text>
                                            <b-collapse visible  id="collapse-a" class="mt-2">
                                                <b-list-group>
                                                    <b-list-group-item  v-if="rows.udata.companyshort">
                                                        <span>Коротка назва:</span> {{ rows.udata.companyshort }}	</b-list-group-item>
                                                    <b-list-group-item  v-else>
                                                        <span>Коротка назва:</span> {{ rows.udata.company }}	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>ЄРДПОУ:</span> {{ rows.edrpou }}	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Організаційно-правова форма:</span> {{ rows.udata.olf_name }}	</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_status ? 'warning' : ''">
                                                        <span>Статус:</span> {{rows.udata.state_text}}	</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_create ? 'warning' : ''">
                                                        <span>Дата державної реєстрації:</span> {{rows.udata.registration_date | moment}}	</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_calital ? 'warning' : ''">
                                                        <span>Розмір статутного капіталу:</span> {{rows.udata.authorised_capital.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн.	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Адреса реєстрації:</span> {{rows.udata.address}}	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Основний вид діяльності згідно КВЕД:</span> {{rows.udata.primary_activity_kind}}	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Ліцензії, дозволи:</span> {{rows.udata.licenses}}	</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_employers ? 'warning' : ''">
                                                        <span>Кількість персоналу:</span> {{rows.udata.employers.num_employers}} ({{ rows.udata.employers.year }} рік)	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Керівник:</span> {{rows.udata.chiefCurrent}} 	</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Кінцевий бенефіціар(и):</span> {{rows.udata.beneficiaries}} 	</b-list-group-item>
                
                                                    <b-list-group-item :variant="rows.udata.termination != null ? 'warning' : ''">
                                                        <span>Відомості про припинення/реорганізацію юр особи:</span> {{rows.udata.termination}} 	</b-list-group-item>
                
                                                    <b-list-group-item :variant="rows.udata.bankruptcy != null ? 'warning' : ''">
                                                        <span>Відомості про банкрутство:</span> {{rows.udata.bankruptcy}} 	</b-list-group-item>
                
                                                    <b-list-group-item :variant="rows.udata.sanctions != 'False' ? 'warning' : ''">
                                                        <span>Зв'язки із компаніями під санкціями:</span> {{rows.udata.sanctions}}</b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Участь у державних тендерах:</span> {{rows.udata.tenders}}</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_borgZP ? 'warning' : ''">
                                                        <span>Заборгованість по заробітній платі:</span> {{rows.udata.debtorsBorgZP.borg}}грн. ({{rows.udata.financialBKI.year}} рік) </b-list-group-item>
                
                                                </b-list-group>
                                            </b-collapse>
                                        </b-card-text>
                                    </b-card>
                                </b-col>
                                <b-col md="3">
                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-button block v-b-toggle.collapse-b variant="success">Дані податкової  <span v-if="chk_borg" class="text-danger"><i class="far fa-exclamation-triangle"></i></span></b-button>
                                        </b-card-header>
                                        <b-card-text>
                                            <b-collapse  id="collapse-b" class="mt-2">
                                                <b-list-group>
                
                                                    <b-list-group-item :variant="chk_borg ? 'warning' : ''">
                                                        <span>Податковий борг:</span> {{rows.udata.debtorsBorgTAX.borg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн. ({{ rows.udata.debtorsBorgTAX.period | moment }})
                                                    </b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Реєстр платників акцизного податку з реалізації пального:</span> {{rows.udata.excise_tax}}
                                                    </b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Реєстр платників ПДВ:</span> {{rows.udata.reestrPdv.state}} {{rows.udata.reestrPdv.ipn}}
                                                    </b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Реєстр платників ПДВ статус:</span> {{rows.udata.reestrPdvCancel.state}} ({{rows.udata.reestrPdvCancel.cancelDate}})
                                                    </b-list-group-item>
                
                                                    <b-list-group-item>
                                                        <span>Реєстр платників єдиного податку:</span> {{rows.udata.reestrPed.state}} ({{rows.udata.reestrPed.cancelDate}})
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </b-collapse>
                                        </b-card-text>
                                    </b-card>
                
                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-button block v-b-toggle.collapse-c variant="success">Фінансово-економічні показники<span v-if="chk_fin" class="text-danger"><i class="far fa-exclamation-triangle"></i></span></b-button>
                                        </b-card-header>
                                        <b-card-text>
                                            <b-collapse  id="collapse-c" class="mt-2">
                                                <b-list-group>
                
                                                    <b-list-group-item :variant="chk_net_income ? 'warning' : ''">
                                                        <span>Виручка:</span> {{rows.udata.financialBKI.net_income.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн. ({{rows.udata.financialBKI.year}} рік)</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_main_active ? 'warning' : ''">
                                                        <span>Основні засоби:</span> {{rows.udata.financialBKI.main_active.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн. ({{rows.udata.financialBKI.year}} рік)</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_net_profit ? 'warning' : ''">
                                                        <span>Чистий прибуток:</span> {{rows.udata.financialBKI.net_profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн. ({{rows.udata.financialBKI.year}} рік)</b-list-group-item>
                
                                                    <b-list-group-item :variant="chk_current_liabilities ? 'warning' : ''">
                                                        <span>Поточні зобов'язання:</span> {{rows.udata.financialBKI.current_liabilities.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} грн. ({{rows.udata.financialBKI.year}} рік)</b-list-group-item>
                                                </b-list-group>
                                            </b-collapse>
                                        </b-card-text>
                                    </b-card>
                                </b-col>
                                <b-col md="3">
                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-button block v-b-toggle.collapse-d variant="success">Майно</b-button>
                                        </b-card-header>
                                        <b-card-text>
                                            <b-collapse  id="collapse-d" class="mt-2">
                                                <b-list-group>
                                                    <b-list-group-item>
                                                        <span>Кількість об'єктів нерухомого майна у власності:</span> {{rows.udata.RealEstate}}</b-list-group-item>
                                                    <b-list-group-item>
                                                        <span>Кількість земельних ділянок у власності:</span> {{rows.udata.realEstateRightsLand}}</b-list-group-item>
                                                    <b-list-group-item>
                                                        <span>Кількість ТЗ у власності:</span> {{rows.udata.vehicle}}</b-list-group-item>
                                                </b-list-group>
                                            </b-collapse>
                                        </b-card-text>
                                    </b-card>
                
                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-button block v-b-toggle.collapse-e variant="success">Судова історія та виконавчі провадження<span v-if="chk_courts_enforcements" class="text-danger"><i class="far fa-exclamation-triangle"></i></span></b-button>
                                        </b-card-header>
                                        <b-card-text>
                                            <b-collapse  id="collapse-e" class="mt-2">
                                                <b-list-group>
                
                                                <b-list-group-item :variant="chk_courts ? 'warning' : ''">
                                                    <span>Кількість судових справ:</span> {{rows.udata.Courts}}</b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.CourtsinProcess)>0 ? 'warning' : ''">
                                                    <span>Кількість судових справ в процесі:</span> {{rows.udata.CourtsinProcess}}</b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.CourtsDocs)>0 ? 'warning' : ''">
                                                    <span>Кількість судових документів:</span> {{rows.udata.CourtsDocs}}</b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.CourtsDocsDefendant)>0 ? 'warning' : ''">
                                                    <span>Кількість судових документів в якості відповідача:</span> {{rows.udata.CourtsDocsDefendant}}</b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.CourtsDocsPlaintiff)>0 ? 'warning' : ''">
                                                    <span>Кількість судових документів в якості Позивача:</span> {{rows.udata.CourtsDocsPlaintiff}}</b-list-group-item>
                                                <b-list-group-item>
                                                    <span >Кількість судових документів за формою судочинства:</span>
                                                    <div v-for="item in rows.udata.listJusticeKindses" > {{item.name}} - {{item.count}}</div></b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.enforcementsOrgCountDebtor)>0 ? 'warning' : ''">
                                                    <span>Кількість виконавчих проваджень в якості боржника:</span> {{rows.udata.enforcementsOrgCountDebtor}}</b-list-group-item>
                                                <b-list-group-item :variant="Number(rows.udata.enforcementsOrgCountCreditor)>0 ? 'warning' : ''">
                                                    <span>Кількість виконавчих проваджень в якості cтягувача:</span> {{rows.udata.enforcementsOrgCountCreditor}}</b-list-group-item>
                                          </b-list-group>
                                            </b-collapse>
                                        </b-card-text>
                
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                            <ul  v-else class="list-group company_full_info">
                                <li class="list-group-item list-group-item-success">Немає даних</li>
                            </ul>
                        <div>
                    </div>
                </b-overlay>
            </div>
    
        
        <template v-slot:modal-footer="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
    </b-modal>
</template>

<script>



    export default {
        name: "company_info",

        components : {

        },

        created() {
            EventBus.$on('show_edrpou_info',this.show_edrpou);
        },

        data() {
            return {
                is_update : false,
                erdpou : "",
                modalShow : false,
                rows : {}
            }
        },

        mounted() {
        
        },

        filters: {
            moment: function (date) {
                return moment(date).format('DD.MM.YYYY');
            },
        },

        methods: {
            
            close() {
                this.erdpou = '';
            },
            
            show_edrpou(edrpou) {
                console.log('Get EDRPOU:',edrpou);
                this.rows = {};
                this.erdpou = edrpou;
                this.load_item(edrpou);
                this.modalShow = true;
            },
            
            async load_item(edrpou) {
               IMC_CORE.showloading();
                await axios
                    .get("https://tenders.imcagro.com.ua/getedrpouinfo/"+edrpou+"/office_imc_agro")
                    .then(({data}) => {
                        IMC_CORE.hideloading();

                        if (data.status === "operation_success") {
                             let rows;
                            rows = data.message;
                            console.log(rows);
                            this.rows = rows;
                            EventBus.$emit('loaded_counterparty',  data.message);
                            this.is_update = false;
                         } else {
                            this.rows = data.message;
                        }
                    })
                    .catch(err => {
                        IMC_CORE.hideloading();
                        this.rows = {};
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    });
            },


            async update_item() {
                this.is_update = true;
                IMC_CORE.showloading();
                await axios.post("https://tenders.imcagro.com.ua/setedrpouinfo/"+this.erdpou+"/office_imc_agro").then(({data}) => {
                    IMC_CORE.hideloading();
                    this.is_update = true;
                    if (data.status === "operation_success") {
                        this.load_item(this.erdpou);
                        EventBus.$emit('show_toast', {err: 'Дані оновлено', type: "success", title: 'Дані оновлено'});
                    } else {

                        EventBus.$emit('show_toast', {err: data.message, type: "danger", title: 'Помилка'});
                    }

                }).catch(err => {
                    this.is_update = true;
                    IMC_CORE.hideloading();
                    this.rows = [];
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});

                });
            },

        },
        computed: {
            chk_info: function () {
                return this.chk_status || this.chk_create || this.chk_calital || this.chk_employers || this.chk_borgZP
            },
            
            chk_status: function () {
                let res = false
                console.log(this.rows.udata)
                if (this.rows.hasOwnProperty('udata')) {
                    res = this.rows.udata.state_text != 'зареєстровано';
                    console.log(this.rows.udata.state_text)
                }
                return res
                
            },
            chk_create: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    var d1 = new Date(this.rows.udata.registration_date);
                    var d2 = new Date();
                    var d1Y = d1.getFullYear();
                    var d2Y = d2.getFullYear();
                    var d1M = d1.getMonth();
                    var d2M = d2.getMonth();
                    res = (d2M + 12 * d2Y) - (d1M + 12 * d1Y) < 24;
                }
                return res
                
            },
            chk_calital: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.authorised_capital) < 100000
                }
                return res
                
            },
            chk_employers: function () {
                let res = false
                
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.employers.num_employers) < 10
                }
                return res
            },
            chk_borgZP: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.debtorsBorgZP.borg) > 0
                }
                return res
                
            },
            
            ///////////////////////////////
            chk_borg: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.debtorsBorgTAX.borg) > 0
                }
                return res
                
            },
            
            ///////////////////////////////
            chk_fin: function () {
                return this.chk_net_income || this.chk_main_active || this.chk_net_profit || this.chk_current_liabilities
                
            },
            
            chk_net_income: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.financialBKI.net_income) < 100000
                }
                return res
            },
            
            chk_main_active: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.financialBKI.main_active) < 100000
                }
                return res
            },
            
            chk_net_profit: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.financialBKI.net_profit) < 0
                }
                return res
            },
            
            chk_current_liabilities: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.financialBKI.net_income) < Number(this.rows.udata.financialBKI.current_liabilities)
                }
                return res
            },
            
            ////////////////////////////
            chk_courts_enforcements: function () {
                return this.chk_courts || this.chk_enforcements
            },
            
            chk_courts: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.Courts) > 0
                }
                return res
            },
            
            chk_enforcements: function () {
                let res = false
                if (this.rows.hasOwnProperty('udata')) {
                    res = Number(this.rows.udata.enforcementsOrgCountDebtor) + Number(this.rows.udata.enforcementsOrgCountCreditor) > 0
                }
                return res
            },
        }
    }
</script>

<style scoped>
.list-group-item {
    padding: 0.15rem 0.25rem;
}
.list-group-item {
    font-size: 0.9rem;
}

</style>
